export const LS_KEY__BG_PROCESSES = 'processes-storage-key';
export const LS_KEY__CLIENT_ID = 'clientid';
export const LS_KEY__CLINCH_TOKEN = 'clinchtoken';
export const LS_KEY__HELP_DRAWER = 'drawer_help_center';
export const LS_KEY__CUSTOM_TAG_COLORS = 'CUSTOM_TAG_COLOR_LS_KEY';
export const LS_KEY__DATE_PICKER_WEEK_STARTS_ON = 'DATE_PICKER_WEEK_STARTS_ON';
export const LS_KEY__INSIGHTS_PRESET_SELECTED = 'LS_KEY_INSIGHTS_PRESET_SELECTED';
export const LS_KEY__HIGHLIGHT_UPDATED_COLUMNS = 'HIGHLIGHT_UPDATED_COLUMNS';
export const LS_KEY__CLINCH_COPILOT_CONTAINER_SETTINGS = 'copilot-container-settings';
export const LS_KEY__COPILOT_STRATEGY_OBJECT = 'copilot-strategy';
export const LS_KEY__LOGIN_RETURN_URL = 'return-url';
export const LS_KEY__MOVIE_EDITOR_MULTI_FORMAT_VIEW = 'movie-editor-multi-format-view';
